import React, { useCallback, useRef, useState } from 'react';
import Filter from '@/pages/dashboard/components/NewFilter';
import moment from 'moment';
import { setBtnPointLog } from "@/pages/dashboard/utils/utils";
import useOutSelector from '@/pages/dashboard/hooks/useOutSelector';
// 筛选器路径
const FILTER_PATH = 'realtime/users/dataDownload';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

// daily筛选器继承逻辑
const RealtimeDownloadFilter = (props: any) => {
  const { filterConfirm, filterReset, filterInit, buttonLogConfig, path = FILTER_PATH, children, timeZone = '+0', isHaveFilterSave = true } = props;
  // const timeDiff = useRef<boolean>(false);
  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新
  const { selectorApi, selectorData, selectorLoading } = useOutSelector(props);
  // 设置inputList,和后端核对后，此次筛选器的展示都是由后端控制，配置为时间，地区，平台和语言四个筛选器
  const [inputList] = useState([
    {
      type: 'singleDaily',
      key: 'singleDaily',
      default: moment().utcOffset(timeZone).format('YYYY-MM-DD'), // 根据时区设置默认值
    },
  ]);

  // 私有化处理，抹平新旧筛选器的差距
  const onInit = useCallback((value) => {
    filterValueRef.current = value;
    const { singleDaily, contrastDaily, ...resetValue } = value;
    filterInit({
      ...resetValue,
      singleDaily,
    });
  }, [filterInit]);

  const onConfirm = useCallback((value) => {
    filterValueRef.current = value;
    const { singleDaily, contrastDaily, ...resetValue } = value;
    const obj: any = {
      ...resetValue,
      singleDaily,
    };
    filterConfirm(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, value);
  }, [filterConfirm]);

  const onReset = useCallback((value) => {
    filterValueRef.current = value;
    const { singleDaily, contrastDaily, ...resetValue } = value;
    const obj = {
      ...resetValue,
      singleDaily,
    };
    filterReset(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, value, true);
  }, [filterReset]);

  return <Filter
    config={props.config}
    openSticky={true}
    path={path}
    latestDateType={''}
    value={filterValueRef.current}
    inputList={inputList}
    onInit={onInit}
    onConfirm={onConfirm}
    onReset={onReset}
    isHaveFilterSave={isHaveFilterSave}
    // 外部传入selectorApi使用其他selector数据源
    {...(selectorApi ? {
      outSelector: selectorData,
      loading: selectorLoading,
    } : {})}
  >
    {children}
  </Filter>;
};

export default RealtimeDownloadFilter;
